(function() {
  'use strict';

  angular.module('component.dashboardTemplates')
    .component('profileTemplatesList', {
      templateUrl: 'app/components/dashboard-templates/list.html',
      controller: 'ProfileTemplatesController',
      controllerAs: 'templatesListCtrl'
    })
    .component('profileTemplateForm', {
      templateUrl: 'app/components/dashboard-templates/form.html',
      controller: 'ProfileTemplateController',
      controllerAs: 'templateFormCtrl',
      bindings: {
        id: '<'
      }
    });
})();
